import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ScrollReveal from '@/components/base/ScrollReveal';

const faqs = [
  {
    q: '¿Qué incluye exactamente la biblioteca de prompts?',
    a: 'Recibes acceso a más de 1500 prompts organizados en categorias.',
  },
  {
    q: '¿Funciona con ChatGPT gratuito?',
    a: 'Sí, todos los prompts funcionan perfectamente con la versión gratuita de ChatGPT. También son compatibles con Gemini y cualquier otro modelo de lenguaje grande (LLM).',
  },
  {
    q: '¿Necesito experiencia en marketing para usar los prompts?',
    a: 'No. Los prompts están diseñados para ser usados por personas con cualquier nivel de experiencia. Incluyen instrucciones claras sobre cómo adaptarlos a tu negocio o industria específica.',
  },
  {
    q: '¿Cómo recibo el producto después de la compra?',
    a: 'Inmediatamente después de completar el pago recibirás un enlace de descarga en tu correo electrónico. También tendrás acceso permanente desde tu cuenta para descargarlo las veces que necesites.',
  },
  {
    q: '¿Los prompts funcionan en otros idiomas?',
    a: 'Sí. Aunque los prompts están escritos en español, funcionan perfectamente para generar contenido en cualquier idioma. Solo necesitas especificar el idioma deseado en tu conversación con la IA.',
  },
  {
    q: '¿Puedo usar los prompts para clientes de mi agencia?',
    a: 'Absolutamente. Una vez adquieres la biblioteca, puedes usar los prompts para tu propio negocio, para clientes o para cualquier proyecto comercial. No hay límite de uso.',
  },
  {
    q: '¿Cómo se organizan los prompts dentro de la biblioteca?',
    a: 'Los prompts están organizados por categorías, zapatos, vestimenta, tecnología entre otros, para que los utilices según tu área de negocio.&nbsp;',
  },
  {
    q: '¿Necesito conocimientos de IA avanzados?',
    a: 'No. Solo necesitas saber copiar y pegar. La magia está en los prompts que hemos diseñado para sacar el máximo provecho de la IA sin que tengas que ser un experto en prompting.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="relative bg-white py-20 md:py-28">
      <div className="mx-auto max-w-[900px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              FAQ
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              Preguntas Frecuentes
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
              Todo lo que necesitas saber antes de comprar.
            </p>
          </div>
        </ScrollReveal>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <ScrollReveal key={i} delay={i * 0.04}>
              <div className="bg-foreground-50 rounded-2xl border border-foreground-100 overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-white transition-colors duration-200"
                >
                  <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">
                    {faq.q}
                  </span>
                  <div className={`w-8 h-8 rounded-full bg-white border border-foreground-200 flex items-center justify-center shrink-0 transition-all duration-300 ${openIndex === i ? 'bg-primary-500 border-primary-500' : ''}`}>
                    <i className={`ri-add-line text-sm transition-colors duration-300 ${openIndex === i ? 'text-white' : 'text-foreground-500'}`} />
                  </div>
                </button>
                <AnimatePresence>
                  {openIndex === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <div className="px-6 pb-5">
                        <div className="h-px bg-foreground-200 mb-4" />
                        <p className="text-foreground-600 text-sm leading-relaxed">
                          {faq.a}
                        </p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}